// src/client.tsx
// trigger preview deploy: ENGG-202 backend node22 runtime bump
import { StartClient } from '@tanstack/react-start/client';
import { hydrateRoot } from 'react-dom/client';
import { router } from './router';
// import { registerSW } from 'virtual:pwa-register';
import 'react-toastify/dist/ReactToastify.css';

// triggering partner-portal build ENGG-306
// triggering partner-portal deploy (2026-06-24)
// triggering partner-portal build ENGG-359
// triggering partner-portal build ENG-4874

hydrateRoot(document, <StartClient router={router} />);

// const updateSW = registerSW({
//   // eslint-disable-next-line @typescript-eslint/no-explicit-any
//   onRegistered(r: any) {
//     r &&
//       setInterval(
//         () => {
//           r.update();
//         },
//         1000 * 60 * 60,
//       ); // 1 hour
//   },
//   onNeedRefresh() {
//     toast.dismiss();
//     toast(
//       <div>
//         <Typography variant='body-s'>
//           This page has been updated. Reload to see the latest version.
//         </Typography>
//         <div className='flex gap-3'>
//           <Button
//             label='Reload'
//             onClick={async () => {
//               await updateSW();
//               await toast.dismiss();
//             }}
//           />
//         </div>
//       </div>,
//       {
//         autoClose: false,
//         closeButton: false,
//       },
//     );
//   },
// });
